// extracted by mini-css-extract-plugin
export default {"wrapper":"AccordionHeading_wrapper__QOjyy"};